var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accordion"},[_c('div',{staticClass:"accordion_titleContainer"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('span',{on:{"click":function($event){_vm.isExpanded = !_vm.isExpanded}}},[_c('i',{class:{
          'budicon-chevron-bottom': !_vm.isExpanded,
          'budicon-chevron-top': _vm.isExpanded,
        }})])]),(_vm.isExpanded)?_c('p',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }